import script from "./AddMetric.vue?vue&type=script&setup=true&lang=js"
export * from "./AddMetric.vue?vue&type=script&setup=true&lang=js"

import "./AddMetric.vue?vue&type=style&index=0&id=6a341c72&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a341c72"]])

export default __exports__